import { useMemo } from 'react';

import { formatLanguagePrefix } from '@lucid/utils';

import type { Lucid } from '../types/types';
import useSiteMetadata from './use-site-metadata';

const URLS = {
  PRODUCT_URL: 'https://lucid.app',
};

const useProductUrls = (urlLangPrefix: Lucid.I18n.LanguagesURLPrefix) => {
  const { siteName } = useSiteMetadata();
  const isProductUrl = siteName.match(/lucid(chart|scale|spark)/gi);
  const siteNameUrl = isProductUrl ? siteName.toLowerCase() : 'documents';

  const urls = useMemo(
    () => ({
      activateUrl: `${URLS.PRODUCT_URL}${formatLanguagePrefix({
        urlLangPrefix: urlLangPrefix,
        url: `/users/login?activate=${isProductUrl ? siteName.toLowerCase() : 'lucidchart'}`,
      })}`,
      newUserUrl: `${URLS.PRODUCT_URL}${formatLanguagePrefix({
        urlLangPrefix,
        url: '/users/level/newUser',
      })}`,
      pricingUrl: `${URLS.PRODUCT_URL}${formatLanguagePrefix({
        urlLangPrefix,
        url: `/pricing/${isProductUrl ? siteName.toLowerCase() : 'lucidchart'}`,
      })}`,
      productUrl: URLS.PRODUCT_URL,
      registerUrl: `${URLS.PRODUCT_URL}${formatLanguagePrefix({
        urlLangPrefix,
        url: `${siteNameUrl}/editNewOrRegister`,
      })}`,
    }),
    [isProductUrl, siteName, siteNameUrl, urlLangPrefix],
  );

  return urls;
};

export default useProductUrls;
